import axios from 'axios';
import { FetchAudioResponse } from 'types/audio';
import { buildQueryUrl } from 'app/utils/utils';
import { AppState } from 'app/store';
import { getPlayAudioLink } from './selectors';

export const fetchAudioWithSrc = async (props: {
  audioGuid: string;
  parentGuid: string;
  state: AppState;
}) => {
  const { audioGuid, parentGuid, state } = props;
  const fetchAudioLink = getPlayAudioLink(state);
  if (!fetchAudioLink) {
    throw new Error("Couldn't fetch audio - missing link");
  }
  try {
    const url = buildQueryUrl(
      fetchAudioLink.href
        .replace('{songGuid}', parentGuid)
        .replace('{audioGuid}', audioGuid),
      {
        waveform: 'desktop',
      }
    );

    const audioResponse = await axios.get<FetchAudioResponse>(url, {
      withCredentials: true,
    });
    return audioResponse.data.response.audio.item;
  } catch (e: any) {
    if (e?.code !== 'ERR_CANCELED') {
      throw e;
    }
    return null;
  }
};
